<pos-app-spinner [show]="loading"></pos-app-spinner>
<div #scheduler_here class="dhx_cal_container panel">
  <div class="dhx_cal_navline">
    <div class="dhx_cal_prev_button">&nbsp;</div>
    <div class="dhx_cal_next_button">&nbsp;</div>
    <div class="dhx_cal_today_button"></div>
    <div class="d-flex">
      <input
        name="d2"
        ngbDatepicker
        #d2="ngbDatepicker"
        [placement]="'bottom'"
        (dateSelect)="goToDate($event)"
        style="padding: 0px; border-width: 0px; margin: 0px; width: 0; overflow: hidden"
      />
      <div class="input-group-append">
        <button class="btn btn-secondary" type="button"><div class="dhx_cal_date" style="font-weight: 300;" (click)="d2.open()"></div></button>
      </div>
    </div>

    <div class="d-flex flex-grow-1 justify-content-center">
      <div class="d-flex">
        <form [formGroup]="searchOrderForm" (submit)="searchOrders()">
          <div style="width: 280px">
            <input
              matInput
              class="p-2 col-md-8"
              placeholder="Search Orders in schedule"
              formControlName="orderNumber"
              (keypress)="($event.charCode >= 48 && $event.charCode < 58)"
            />
            <button class="col-md-2 btn text-white" style="height: 38px" type="submit" [disabled]="!searchOrderForm.valid">
              <mat-icon> search </mat-icon>
            </button>
          </div>
        </form>
      </div>
    </div>

    <div>
      <div class="row">
        <div class="col">
          <button class="btn text-white" (click)="goToWeekView()">WEEK</button>
          <button class="btn text-white" (click)="legendView()">LEGEND</button>
          <div ngbDropdown class="d-inline-block">
            <button class="btn text-white" id="dropdownBasic1" ngbDropdownToggle>RESOURCE</button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="dropdown-menu-right" style="left: -8.5rem">
              <button ngbDropdownItem (click)="resourceAdd()">ADD</button>
              <button ngbDropdownItem (click)="resourceChange()">CHANGE</button>
              <button style="margin-left: 0px" ngbDropdownItem (click)="resourceRemove()">REMOVE</button>
            </div>
          </div>
          <div ngbDropdown class="d-inline-block">
            <button class="btn text-white" id="dropdownBasic1" ngbDropdownToggle>WORKSHOP</button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="dropdown-menu-right" style="left: -8.5rem">
              <button ngbDropdownItem (click)="setWorkshopDay()">SET DAY</button>
              <button style="margin-left: 0px" ngbDropdownItem (click)="setWorkshopHour()">SET HOURS</button>
            </div>
          </div>

          <button *ngIf="showSMS" class="btn text-white" (click)="sendSMSReminder(true, 0, '')">SEND SMS REMINDER</button>
        </div>
      </div>
    </div>
  </div>
  <div class="dhx_cal_header"></div>
  <div class="dhx_cal_data"></div>
</div>

<p-confirmDialog header="Warning" #sendSMSConfirmation key="sendSMSConfirmation">
  <p-footer>
    <button type="button" class="btn text-white" (click)="sendSMSConfirmation.accept()" style="width: 80px">OK</button>
    <button type="button" class="btn btn-cancel" (click)="sendSMSConfirmation.reject()">Cancel</button>
  </p-footer>
</p-confirmDialog>

<p-confirmDialog header="Result" #sendSMSResult key="sendSMSResult">
  <p-footer>
    <button type="button" class="btn text-white" (click)="sendSMSResult.accept()" style="width: 80px">OK</button>
  </p-footer>
</p-confirmDialog>

<p-confirmDialog header="Warning" #goToDateResult key="goToDateResult">
  <p-footer>
    <button type="button" class="btn text-white" (click)="goToDateResult.accept()" style="width: 80px">OK</button>
  </p-footer>
</p-confirmDialog>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">LEGEND</h4>
  </div>
  <div class="modal-body">
    <div class="d-flex justify-content-evenly flex-row">
      <div class="d-flex flex-column">
        <div *ngIf="jobTypeLegend" class="text-center">
          <label>JOB TYPE</label>
          <div *ngFor="let jobType of jobTypeLegend">
            <div *ngIf="jobType.borderOrFill === 'BORDER'" class="mb-2 p-1" [style.border]="'2px solid #' + jobType.colourCode">
              {{ jobType.longDescription }}
            </div>
            <div *ngIf="jobType.borderOrFill === 'FILL'" class="mb-2 p-1 text-white" [style.background-color]="'#' + jobType.colourCode">
              {{ jobType.longDescription }}
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-column">
        <div *ngIf="vehicleStatusLegend" class="text-center">
          <label>VEHICLE STATUS</label>
          <div *ngFor="let vehicleStatus of vehicleStatusLegend">
            <div *ngIf="vehicleStatus.borderOrFill === 'BORDER'" class="mb-2 p-1" [style.border]="'2px solid #' + vehicleStatus.colourCode">
              {{ vehicleStatus.longDescription }}
            </div>
            <div *ngIf="vehicleStatus.borderOrFill === 'FILL'" class="mb-2 p-1 text-white" [style.background-color]="'#' + vehicleStatus.colourCode">
              {{ vehicleStatus.longDescription }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div>
    <div class="pt-2">
      <div class="row px-2 flex-nowrap fitter-row-position position-relative"></div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="col d-flex float-end justify-content-end">
      <button class="btn btn-cancel mx-1 px-2" (click)="handleCloseModal(true)">CLOSE</button>
    </div>
  </div>
</ng-template>
